import React from 'react';

export function Loading(){
    return(
        <>
         <div className="lds-ring"><div></div><div></div><div></div><div></div></div>
        </>
    )
}